import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierActivity extends Layout {
    sourceCarrierActivity: DataSource;
    textboxDays: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxNextId: Textbox;
}
